import { Inject, Component, OnDestroy, ViewChild } from '@angular/core';
import { IonicPage, NavController, ModalController , AlertController, TextInput, Events} from 'ionic-angular';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';

import { CalendarModal, CalendarModalOptions, CalendarResult } from "ion2-calendar";

//Providers
import { SBSuiteManager } from '../../modules/sbsuite/providers/sbsuite.manager';

//Decorators
import  { RedirectOnUserAttr } from '../../decorators/redirect-on-user-attr.decorator';

//Pages 
import { EditClockIn } from './edit-clock-in';

//RxJS
import { Subscriber } from 'rxjs';

import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/ca';
import { ClockIn } from '../../modules/sbsuite/models/clock-in.model';
import { ClassStmt } from '@angular/compiler';

import MapLocationModal from '../maplocation/maplocation.modal';



/**
 * Página para manejar las fichadas manuales 
 *
 * @export
 * @class ManuallyClocking
 * @implements {OnDestroy}
 */
@RedirectOnUserAttr()
@IonicPage({
  name: 'ManuallyClocking',
  segment: 'fichada-manual'
})
@Component({
  selector: 'page-manually-clocking',
  templateUrl: 'manually-clocking.html',
  styles: [`
    ion-scroll {
    height: 100px;
    }
  `]
})
export class ManuallyClocking implements OnDestroy {

  /**
   * TextInput de operario.
   *
   * @type {TextInput}
   * @memberof ManuallyClocking
   */
  @ViewChild('operatorInput') operatorInput: TextInput;

  /**
   * Contiene el tab actual.
   * 
   * 'man' para esta página.
   *
   * @type {string}
   * @memberof ManuallyClocking
   */
  currentTab: string = 'man';


  /**
   * Contiene los textos traducidos.
   *
   * @type {*}
   * @memberof ManuallyClocking
   */
  texts: any = null;

  /**
   * Flag de seleccion de operador.
   *
   * @type {boolean}
   * @memberof ManuallyClocking
   */
  focusedOperator: boolean = false;

  /**
   * Guarda el valor del operador al realizar focus.
   *
   * @type {string}
   * @memberof ManuallyClocking
   */
  focusOperatorValue: string = '';

  /**
   * Contiene el filtro de fecha.
   *
   * @private
   * @type {string}
   * @memberof ManuallyClocking
   */
  private _date: string = moment().format('YYYYMMDD');
  
  /**
   * Data getter.
   * 
   * Devuelve la fecha en formato local 'L'.
   *
   * @type {string}
   * @memberof ManuallyClocking
   */
  get date(): string{
    let parseDate = moment(this._date,'YYYYMMDD').format('L');
    return parseDate;
  }

  /**
   * Data setter.
   * 
   * El formato debe ser YYYYMMDD.
   *
   * @memberof ManuallyClocking
   */
  set date(date: string){
    this.date = date;
  }

  /**
   * Contiene la subscripción a translateService.onLangChange
   *
   * @private
   * @type {Subscriber<TranslationChangeEvent>}
   * @memberof ManuallyClocking
   */
  private _translateListener: Subscriber<TranslationChangeEvent> = null;

  /**
   * Crea la instancia de ManuallyClocking.
   *  - Inicia la traducción de los textos
   *  - Observa los cambios del servicio de traducción
   *  - Assigna el moment.locale en función del idioma
   * 
   * @param {NavController} navCtrl Controlador de navegación.
   * @param {ModalController} modalCtrl Controlador de modales.
   * @param {TranslateService} translateService Servicio de traducción.
   * @param {SBSuiteManager} sbSuiteManager Gestor de sbSuite.
   * @param {AlertController} _alertCtrl Controlador de alertas.
   * @memberof ManuallyClocking
   */
  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public translateService: TranslateService,
    public sbSuiteManager: SBSuiteManager,
    private _alertCtrl: AlertController,
    private _events: Events
    //private _modalCtrl: ModalController
  ) {

      this.getTranslate();
      this._translateListener = this.translateService.onLangChange.subscribe((event: TranslationChangeEvent) => {
        moment.locale(event.lang);
        this.getTranslate();
    });


    if(this.sbSuiteManager.sbSuite.manuallyOperator){
      this.sbSuiteManager.getOfsOperario(this.sbSuiteManager.sbSuite.manuallyOperator,this.sbSuiteManager.sbSuite.getRequestDate());
    }
    
  }



  /**
   * Implementa el hook OnDestroy.
   *
   * @memberof ManuallyClocking
   */
  ngOnDestroy(): void{
    if(this._translateListener) this._translateListener.unsubscribe();
  }


  /**
   * Observa los cambios
   *
   * @memberof ManuallyClocking
   */
  getTranslate(): void{
    this.translateService.get([
      'WAIT_PLEASE',
      'SELECT_DATE',
      'CANCEL',
      'DONE',
      'MO',
      'PRODUCT',
      'OPERATION',
      'DELETE',
      'DELETE_REGISTER',
      'DELETE_REGISTER_EXT'


    ]).subscribe(res => {
      this.texts = res;
    });
  }


  /**
   * Cambia el tab activo
   *
   * @memberof ManuallyClocking
   */
  tabChoose(): void{
    this.navCtrl.setRoot('AutoClocking');
  }


  /**
   * Especifica el operador actual
   *
   * @param {string} value Código del operador
   * @memberof ManuallyClocking
   */
  setOperator(value: string) : void{
    this.sbSuiteManager.sbSuite.manuallyOperator = value;
  }


  /**
   * Función de trackBy para la lista de fichadas.
   *
   * @param {*} index Posición de la lista 
   * @param {*} item Item de la lista
   * @returns
   * @memberof ManuallyClocking
   */
  trackByFn(index, item) {
    return index; // or item.id
  }


  /**
   * 
   *
   * @param {string} [time='']
   * @returns
   * @memberof ManuallyClocking
   */
  getTime(time: string = ''){
    let split = time.split(' ');
    if(split.length<1) return time;
    return split[1];

  }


  /**
   * Abre la vista de edición manual de una fichada
   *
   * @memberof ManuallyClocking
   */
  openAdd(): void{
    this.sbSuiteManager.sbSuite.hIndex = null;
    this.navCtrl.push(EditClockIn);
  }

  /**
   *  Abre la vista de edición manual de una fichada
   *
   * @param {number} [index=0]
   * @memberof ManuallyClocking
   */
  openEdit(index: number = 0): void{
    this.sbSuiteManager.sbSuite.hIndex = index;
    this.navCtrl.push(EditClockIn);
  }

   /**
   * Realiza el focus del input de operador.
   *
   * @memberof ManuallyClocking
   */
  focusingOperator(){
    this.operatorInput.setFocus();
  }

  /**
   * Evento al realizar focus al input de operador.
   *
   * @memberof ManuallyClocking
   */
  focusOperator(){
    this.focusOperatorValue = this.operatorInput.value;
    this.focusedOperator = true;
  }

  /**
   * Evento al perder el focus del input del operador.
   *
   * @memberof ManuallyClocking
   */
  blurOperator(){
    this.focusedOperator = false;
    if(this.focusOperatorValue != this.operatorInput.value) this.sbSuiteManager.cambiarOperario(this.sbSuiteManager.sbSuite.manuallyOperator,'manually');
  }

  /**
   * Abre el popup de selección de fecha
   *
   * @memberof ManuallyClocking
   */
  openCalendar(): void {
    let weekDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    if(this.translateService.getDefaultLang() == 'es'){
      weekDays = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];
    } 
    if(this.translateService.getDefaultLang() == 'ca'){
      weekDays = ['Dg', 'Dll', 'Dm', 'Dm', 'Dj', 'Dv', 'Ds'];
    }
    
    let fromDate = new Date();
    fromDate.setFullYear(fromDate.getFullYear()-1);

    let cmOptions: CalendarModalOptions = {
      from: fromDate,
      defaultScrollTo: new Date(),
      title: this.texts.SELECT_DATE,
      weekStart: this.translateService.getDefaultLang()=='en'?0:1,
      weekdays: weekDays,
      format: 'YYYYMMDD',
      doneLabel: this.texts.DONE,
      closeLabel: this.texts.CANCEL 
    };


    let myCalendar =  this.modalCtrl.create(CalendarModal, {
      options: cmOptions
    });

    myCalendar.present();

    myCalendar.onDidDismiss((date: CalendarResult, type: string) => {
      if(type == 'done'){
        this.sbSuiteManager.sbSuite.filterDate = moment(date.string,'YYYY-MM-DD').format('YYYYMMDD')
        if(this.sbSuiteManager.sbSuite.manuallyOperator)  this.sbSuiteManager.getOfsOperario(this.sbSuiteManager.sbSuite.manuallyOperator,this.sbSuiteManager.sbSuite.getRequestDate());
      } 
    })
  }

  deleteAlert(index: string = null){
    if(index === null) return;
    let clockIn: ClockIn = this.sbSuiteManager.sbSuite.clocking.history[index];
    let alert = this._alertCtrl.create({
      title: this.texts.DELETE_REGISTER,
      subTitle: this.texts.DELETE_REGISTER_EXT + ':',
      message: `
          <ul>
            <li><b>${this.texts.MO}</b>: ${clockIn.manufacturingOrder}</li>
            <li><b>${this.texts.PRODUCT}</b>: ${clockIn.getProductsList()}</li>
            <li><b>${this.texts.OPERATION}</b>: ${clockIn.getOperationName()}</li>
          </ul>
        `,
      buttons: [
        {
          text: this.texts.CANCEL,
          role: 'cancel',
          handler: data => {
          }
        },
        {
          text: this.texts.DELETE,
          handler: data => {
            this.sbSuiteManager.delHorasOpProdOf(clockIn.register);
            return true;
          }
        }
      ]
    });
    alert.present();
  }


  /**
   * Abre un alert
   *
   * @param {string} [title=''] Título del alert
   * @param {string} [message='En desarrollo'] Mensaje del alert
   * @memberof ManuallyClocking
   */
  functionAlert(title: string = '', message: string = 'En desarrollo'): void{
    let alert = this._alertCtrl.create({
      title: title,
      message: message,
      buttons: ['OK']
    });
    alert.present();
  }

   /**
   * Abre el modal para seleccionar producto.
   *
   * @param {*} data
   * @memberof MyApp
   */
  presentMapLocationStartClick(data: any): void {
    this._events.publish('map:createdStart', data, Date.now());    
  }

  /**
   * Abre el modal para seleccionar producto.
   *
   * @param {*} data
   * @memberof MyApp
   */
  presentMapLocationEndClick(data: any): void {
    this._events.publish('map:createdEnd', data, Date.now());    
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/manually-clocking/manually-clocking.ts